// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-n_fE","advertDetailContactGroup__header":"c-n_fF","advertDetailContactGroup__value":"c-n_fG"};